import { IBenefit } from '../../types/developer/benefits';
import { IApplicationState } from '../../types/redux';

const emptyBenefits = Array.of<IBenefit>();

export function getBenefits(state: IApplicationState) {
  if (state.fsk?.promoTiles) {
    return state.fsk.promoTiles.map((promoTile, index) => ({
      description: promoTile.description,
      id: index,
      image: promoTile.image,
      title: promoTile.title,
      url: '#',
    }));
  }

  if (!state.developer) {
    return emptyBenefits;
  }

  return state.developer.benefits;
}
